/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileRefSchema } from './FileRefSchema';
import {
    FileRefSchemaFromJSON,
    FileRefSchemaFromJSONTyped,
    FileRefSchemaToJSON,
} from './FileRefSchema';
import type { JobFileSchema } from './JobFileSchema';
import {
    JobFileSchemaFromJSON,
    JobFileSchemaFromJSONTyped,
    JobFileSchemaToJSON,
} from './JobFileSchema';
import type { RunTaskActionWhenDoneEnum } from './RunTaskActionWhenDoneEnum';
import {
    RunTaskActionWhenDoneEnumFromJSON,
    RunTaskActionWhenDoneEnumFromJSONTyped,
    RunTaskActionWhenDoneEnumToJSON,
} from './RunTaskActionWhenDoneEnum';

/**
 * 
 * @export
 * @interface RunTaskSchema
 */
export interface RunTaskSchema {
    /**
     * 
     * @type {number}
     * @memberof RunTaskSchema
     */
    jobId: number;
    /**
     * 
     * @type {string}
     * @memberof RunTaskSchema
     */
    command: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RunTaskSchema
     */
    setupCommands?: Array<string>;
    /**
     * 
     * @type {Array<JobFileSchema>}
     * @memberof RunTaskSchema
     */
    files: Array<JobFileSchema>;
    /**
     * 
     * @type {Array<FileRefSchema>}
     * @memberof RunTaskSchema
     */
    fileRefs: Array<FileRefSchema>;
    /**
     * 
     * @type {RunTaskActionWhenDoneEnum}
     * @memberof RunTaskSchema
     */
    doneAction?: RunTaskActionWhenDoneEnum;
    /**
     * 
     * @type {string}
     * @memberof RunTaskSchema
     */
    remoteOutputPath?: string;
    /**
     * 
     * @type {number}
     * @memberof RunTaskSchema
     */
    taskId: number;
    /**
     * 
     * @type {number}
     * @memberof RunTaskSchema
     */
    arrayTaskId: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RunTaskSchema
     */
    envVars?: { [key: string]: string; };
}

/**
 * Check if a given object implements the RunTaskSchema interface.
 */
export function instanceOfRunTaskSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jobId" in value;
    isInstance = isInstance && "command" in value;
    isInstance = isInstance && "files" in value;
    isInstance = isInstance && "fileRefs" in value;
    isInstance = isInstance && "taskId" in value;
    isInstance = isInstance && "arrayTaskId" in value;

    return isInstance;
}

export function RunTaskSchemaFromJSON(json: any): RunTaskSchema {
    return RunTaskSchemaFromJSONTyped(json, false);
}

export function RunTaskSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunTaskSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobId': json['job_id'],
        'command': json['command'],
        'setupCommands': !exists(json, 'setup_commands') ? undefined : json['setup_commands'],
        'files': ((json['files'] as Array<any>).map(JobFileSchemaFromJSON)),
        'fileRefs': ((json['file_refs'] as Array<any>).map(FileRefSchemaFromJSON)),
        'doneAction': !exists(json, 'done_action') ? undefined : RunTaskActionWhenDoneEnumFromJSON(json['done_action']),
        'remoteOutputPath': !exists(json, 'remote_output_path') ? undefined : json['remote_output_path'],
        'taskId': json['task_id'],
        'arrayTaskId': json['array_task_id'],
        'envVars': !exists(json, 'env_vars') ? undefined : json['env_vars'],
    };
}

export function RunTaskSchemaToJSON(value?: RunTaskSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'job_id': value.jobId,
        'command': value.command,
        'setup_commands': value.setupCommands,
        'files': ((value.files as Array<any>).map(JobFileSchemaToJSON)),
        'file_refs': ((value.fileRefs as Array<any>).map(FileRefSchemaToJSON)),
        'done_action': RunTaskActionWhenDoneEnumToJSON(value.doneAction),
        'remote_output_path': value.remoteOutputPath,
        'task_id': value.taskId,
        'array_task_id': value.arrayTaskId,
        'env_vars': value.envVars,
    };
}

